import React from 'react';
import { Grid, InputAdornment } from '@mui/material';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

import * as Style from './styles';

function SearchBar({
    searchFilter,
    setSearchFilter,
}) {
    const handleSearch = e => {
        setSearchFilter(e);
    };

    return (
        <Grid item container justifyContent="center">
            <Style.SearchBar
                fullWidth
                shrink="true"
                variant="outlined"
                placeholder="Buscar"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchOutlinedIcon
                                style={{
                                    color: '#DCC6B7',
                                }}
                            />
                        </InputAdornment>
                    ),
                    style: { height: '42px' },
                }}
                value={searchFilter}
                onChange={e => {
                    handleSearch(e.target.value);
                }}
            />
        </Grid>
    );
}

export default SearchBar;
